<template>
    <div class="bg-fixed h-full w-full bg-cover bg-center bg-no-repeat bg-[url('../../assets/about.jpg')]" style="font-family: Caveat;">
        <div class="w-full h-screen">
        <h1 class="text-gray-100 font-bold sm:text-[5rem] pt-16 text-[3rem]">{{ $t('about.who')}}?</h1>
        <div class="bg-gray-100 rounded-[5rem] pb-8 lg:mx-72 group hover:bg-black hover:text-white transition ease-out hover:duration-700 hover:ease-in-out">
          <vue-marquee-slider
            id="marquee-slider"
            :speed="20000"
            :height="50"
            class="text-2xl mt-10"
          >
          <h1 class="mt-8 text-2xl font-bold">{{$t('about.who')}}</h1>
          <h1 class="mt-8 text-2xl font-bold">{{$t('about.who')}}</h1>
          <h1 class="mt-8 text-2xl font-bold">{{$t('about.who')}}</h1>
          <h1 class="mt-8 text-2xl font-bold">{{$t('about.who')}}</h1>
          </vue-marquee-slider>
          <div class="lg:mx-16 lg:flex">
            <div class="lg:flex lg:flex-1 mt-5 lg:h-64 lg:w-64 h-32 w-32 mx-auto">
              <img src="../../assets/profile.jpg" alt="" class="rounded-full">
            </div>
            <p class="lg:flex lg:flex-1 md:text-left font-base md:mt-10 md:mr-16 text-2xl font-semibold -mt-4 p-4 my-auto mx-auto" style="font-family: Caveat;">{{ $t('about.pa') }}</p>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "About",
};
</script>
